import "./logo.svg";
import "./App.scss";
import { Alert, CssBaseline, Snackbar, ThemeProvider } from "@mui/material";
import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import { useRecaptcha, useSnackbar } from "./store/store";
import { APP_NAME } from "./constants";
import { ResponsiveDrawer } from "./components/Drawer";
import { useMedia } from "react-use";
import { darkTheme, lightTheme } from "./themes";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

const queryClient = new QueryClient();

const MyThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const isDarkTheme = useMedia("(prefers-color-scheme: dark)");
  const theme = isDarkTheme ? darkTheme : lightTheme;
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

const Providers: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore

  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <MyThemeProvider>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          {children}
        </LocalizationProvider>
      </MyThemeProvider>
    </BrowserRouter>
  </QueryClientProvider>
);

export const Recaptha: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { recaptchaFailed } = useRecaptcha();

  if (recaptchaFailed) {
    return <div>Low recaptcha score.</div>;
  }

  return <>{children}</>;
};

const SnackbarComponent = () => {
  const snackbar = useSnackbar();
  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    snackbar.close();
  };

  return (
    <Snackbar open={snackbar.opened} onClose={handleClose}>
      <Alert
        onClose={handleClose}
        severity={snackbar.type}
        sx={{ width: "100%" }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
};

export const AppWithProviders = () => (
  <Providers>
    <SnackbarComponent />
    <title>Spidipay</title>
    <Recaptha>
      <ResponsiveDrawer />
    </Recaptha>
  </Providers>
);

export default AppWithProviders;
